import React from 'react';
import { Calendar } from 'lucide-react';

export default function CalendarPermissionModal({ show, pendingCalendar, onClose }) {
  if (!show) return null;

  return (
    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl w-full max-w-xs p-6 text-center">
        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Calendar size={24} className="text-blue-600" />
        </div>

        {/* Apple Calendar - browser limitation message */}
        {pendingCalendar === 'apple' && (
          <>
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              Apple Calendar
            </h3>
            <p className="text-sm text-gray-500 mb-6">
              Apple Calendar will be available when you install the AppDHD iOS app. Your calendar will sync automatically.
            </p>
            <button
              onClick={onClose}
              className="w-full bg-blue-500 text-white rounded-lg p-3 font-semibold"
            >
              Got it
            </button>
          </>
        )}

        {/* Apple Calendar - denied permission in native app */}
        {pendingCalendar === 'apple-denied' && (
          <>
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              Calendar Access Denied
            </h3>
            <p className="text-sm text-gray-500 mb-6">
              Calendar permission was denied. To enable it, go to your device Settings &gt; AppDHD &gt; Calendars and allow access.
            </p>
            <button
              onClick={onClose}
              className="w-full bg-blue-500 text-white rounded-lg p-3 font-semibold"
            >
              Got it
            </button>
          </>
        )}

        {/* Google Calendar - fallback when no client ID configured */}
        {pendingCalendar === 'google' && (
          <>
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              Google Calendar Setup Required
            </h3>
            <p className="text-sm text-gray-500 mb-6">
              Google Calendar integration requires a Google Cloud client ID. Add your client ID to the .env file to enable this feature.
            </p>
            <button
              onClick={onClose}
              className="w-full bg-blue-500 text-white rounded-lg p-3 font-semibold"
            >
              Got it
            </button>
          </>
        )}
      </div>
    </div>
  );
}
